import {Moment} from 'moment';

interface EntitlementStatusModel {
   level: string;
   expirationDate: Moment;
   expires: boolean;
   status: string;
}

export const nullEntitlementStatusFactory = (initialData?: Partial<EntitlementStatusModel>): EntitlementStatusModel => Object.assign({
   level: '',
   expirationDate: null,
   expires: false,
   status: ''
}, initialData);

export default EntitlementStatusModel;
